

export function isEmptyCollection(iterable: Map<any, any> | Set<any>) {
    return iterable.size === 0;
}

export function isNotEmptyCollection(iterable: Map<any, any> | Set<any>) {
    return !isEmptyCollection(iterable);
}